/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function PGE_42_MainPageInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Provincial General Election 2024"
              description={
                <>
                  <h4>The 42nd Provincial General Election was held in Nova Scotia on Tuesday, November 26, 2024.</h4>
                  {/* <br />
                  <h3>Recount Results – Electoral District 55 Yarmouth</h3>
                  <br />
                  <p>A judicial recount of all ballots cast in electoral district 55 Yarmouth for the 42nd provincial general election, was held on Monday, December 9, 2024. The application for this judicial recount was made by Liberal candidate Zach Churchill.</p>
                  <br /><p>The results of the recount are as follows:</p>
                  <br /><p>Zach Churchill, Nova Scotia Liberal Party (Liberal) – 3,647</p>
                  <br /><p>Nick Hilton,  Progressive Conservative Association of Nova Scotia (PC) – 3,663</p>
                  <br /><p>Adam Randall, Green Party of Nova Scotia (Green Party) -  62</p>
                  <br /><p>Gillian Rowley, Nova Scotia New Democratic Party (NSNDP) - 208</p>
                  <br /><p>Following the recount, Nick Hilton PC was confirmed as the winning candidate for Nova Scotia.</p>
                  <br /><p>The previous results following the provincial general election on Tuesday, November 26, 2024 in the electoral district of Yarmouth were as follows:</p>
                  <br /><p>Zach Churchill, Liberal – 3,649</p>
                  <br /><p>Nick Hilton, PC – 3,663</p>
                  <br /><p>Adam Randall, Green Party - 62</p>
                  <br /><p>Gillian Rowley, NSNDP - 211</p>

                  <br /><h3>Recount Results – Electoral District 1 Annapolis</h3>

                  <br /><p>A judicial recount of all ballots cast in electoral district 1 Annapolis for the 42nd provincial general election, was held on Tuesday, December 10, 2024. The application for this recount was made by Elections Nova Scotia under clause 148 (3)(b)(c)(d) of the Elections Act, because there are only 7 votes separating the top two candidates. </p>

                  <br /><p>The results of the recount are as follows:</p>

                  <br /><p>Sara Adams, Green Party of Nova Scotia (Green Party) - 138</p>
                  <br /><p>David Bowlby, Progressive Conservative Association of Nova Scotia (PC) – 3,289</p>
                  <br /><p>Cheryl Burbridge, Nova Scotia New Democratic Party (NSNDP) - 689</p>
                  <br /><p>Carman Kerr, Nova Scotia Liberal Party (Liberal) – 3,281</p>

                  <br /><p>Following the recount, David Bowlby PC was confirmed as the winning candidate for Nova Scotia.</p>

                  <br /><p>The previous results following the provincial general election on Tuesday, November 26, 2024 in the electoral district of Annapolis were as follows:</p>

                  <br /><p>Sara Adams, Green Party - 139</p>
                  <br /><p>David Bowlby, PC – 3,291</p>
                  <br /><p>Cheryl Burbridge, NSNDP - 689</p>
                  <br /><p>Carman Kerr, Liberal – 3,284</p>


                  <br /><p>The deadline to apply for a judicial recount for the provincial general election was Monday, December 2, 2024.</p> */}

                  <br />
                  <h3>Provincial General Election Official Results</h3>
                  <br />
                  {/* <p>Official addition results for the 55 electoral districts are now available on the Elections Nova Scotia website (electionsnovascotia.ca).</p>
                  <br />
                  <p>Follow this link to view the <u><a href="https://results.electionsns.ca/">official results</a></u> for the 42nd provincial general election.</p>
                  <br /> */}
                  <p>The following indicates the number of electoral districts for each registered political party and independent candidates:</p>

                  <br /><p>Green Party: 0 electoral districts</p>
                  <br /><p>Liberal: 2 electoral districts</p>
                  <br /><p>NDP: 9 electoral districts</p>
                  {/* <br /><p>NS United: 0 electoral districts</p> */}
                  <br /><p>PC Party: 43 electoral districts</p>
                  <br /><p>Independent candidates: 1 electoral districts</p>

                  {/* <br /><p>The total number of ballots cast was 356,308.</p> */}

                  {/* <br /><p>As of Sunday, November 24, 2024, there were 788,427 registered voters in Nova Scotia.</p>


                  <br /><p>A candidate is officially declared elected when the writ of election has been completed and returned by the returning officer to the Chief Electoral Officer per section 159 of the <u><i><a href="http://nslegislature.ca/legc/statutes/elections.pdf"><em>Elections Act</em></a></i></u>.</p>
                  <br />
                  <p>Poll-by-poll results and further analysis on voter turnout for the provincial general election will be published in Elections Nova Scotia’s post-election report in the coming months.</p> */}
                  <br />

                  {/* <h3>Statement of Votes and Statistics, Volume I Report</h3>
                  <br/>
                  <p>Chief Electoral Officer, Dorothy Rice, has released the first volume of post-election reporting for the 42nd provincial general election held on November 26, 2024. </p>
                  <br/>
                  <p>The Statement of Votes & Statistics, Volume I report was submitted to the Legislative Assembly, in accordance with Section 163 of the Elections Act. </p>
                  <br/>
                  <p>The Report of the Chief Electoral Officer on the Proceedings of the 42nd provincial general election is presented in three volumes. </p>
                  <br/>
                  <p>Volume I, Statement of Votes & Statistics, provides a summary of the election results and detailed statistics. The Volume I report is posted on the 42nd provincial general election <u><a href="/GeneralElection_42nd">results page</a></u> on this website. </p>
                  <br/>
                  <p>Volume II, Report on the Conduct of the Election and Recommendations for Legislative Change, will include analysis of statistics provided in Volume I as well as my recommendations for changes to the Elections Act. </p>
                  <br/>
                  <p>Volume III, Financial Information and Statistics, will provide financial information on election expenses, candidate reimbursement, election administration costs and savings, as well as financial statistics. </p>
                  <br/>
                  <p>Volume II and Volume III will be released later this year.</p>
                  <br /> */}

                  <h3>Post Election Reporting</h3>
                  <br/>
                  <p>The Report of the Chief Electoral Officer (CEO) on the proceedings of the 42nd Provincial General Election (PGE) is presented in three volumes.</p>
                  <br/>
                  <p>Volume I, Statement of Votes & Statistics, provides a summary of the election results and detailed statistics. The Volume I report was released on May 7, 2025 and is posted on the 42nd PGE <u><a href="/GeneralElection_42nd">results page</a></u> on this website.</p>
                  <br/>
                  <p>Volume II, Report on the Conduct of the Election and Recommendations for Legislative Change, includes analysis of statistics provided in Volume I as well as the CEO’s recommendations for changes to the <a href="http://nslegislature.ca/legc/statutes/elections.pdf"><em><u>Elections Act</u></em></a>. The 11 recommendations for legislative change presented in the Volume II report are grouped into three themes: Electoral Finance, Transparency, and Clarity. Each recommendation presented in the report includes a brief explanation as to why the CEO is proposing the change to be considered by Members of the House of Assembly. The report also includes background on the status of recommendations for legislative change made following the 41st PGE held in 2021. The Volume II report was released on September 11, 2025 and is posted on the 42nd PGE <u><a href="/GeneralElection_42nd">results page</a></u> on this website.</p>
                  <br/>
                  <p>Volume III, Financial Information and Statistics provides financial information on election expenses, candidate reimbursement, election administration costs and savings, as well as financial statistics. This report was released on February 17, 2026, and is posted on the 42nd PGE <u><a href="/GeneralElection_42nd">results page</a></u> on this website.</p>
                  <br />

                  <h3>List of Elected</h3>
                  <br />
                  <table border="1" cellPadding="1" cellSpacing="1">
                    <thead>
                      <tr>
                        <th>Electoral District</th>
                        <th>Elected Candidate</th>
                        <th>Registered Political Party or Independent</th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="style1" style={{ height: '25px' }}>Annapolis</td>
                        <td className="style1">David Bowlby</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1" style={{ height: '30px' }}>Antigonish</td>
                        <td className="style1">Michelle Thompson</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Argyle</td>
                        <td className="style1">Colton LeBlanc</td>
                        <td className="style1">PC</td>

                      </tr>
                      <tr>
                        <td className="style1">Bedford Basin</td>
                        <td className="style1">Tim Outhit</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Bedford South</td>
                        <td className="style1">Damian Stoilov</td>
                        <td className="style1">PC</td>

                      </tr>
                      <tr>
                        <td className="style1">Cape Breton Centre-Whitney Pier</td>
                        <td className="style1">Kendra Coombes</td>
                        <td className="style1">NSNDP</td>
                      </tr>
                      <tr>
                        <td className="style1">Cape Breton East</td>
                        <td className="style1">Brian Comer</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Chester-St. Margaret&#39;s </td>
                        <td className="style1">Danielle Barkhouse</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Clare </td>
                        <td className="style1">Ryan Robicheau</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Clayton Park West </td>
                        <td className="style1">Adegoke Fadare</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Colchester-Musquodoboit Valley </td>
                        <td className="style1">Scott Armstrong</td>
                        <td className="style1">PC</td>

                      </tr>
                      <tr>
                        <td className="style1">Colchester North </td>
                        <td className="style1">Tom Taggart</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Cole Harbour</td>
                        <td className="style1">Leah Martin</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Cole Harbour-Dartmouth </td>
                        <td className="style1">Brad McGowan</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Cumberland North</td>
                        <td className="style1">Elizabeth Smith-McCrossin</td>
                        <td className="style1">Independent</td>
                      </tr>
                      <tr>
                        <td className="style1">Cumberland South </td>
                        <td className="style1">Tory Rushton</td>
                        <td className="style1">PC</td>

                      </tr>
                      <tr>
                        <td className="style1">Dartmouth East</td>
                        <td className="style1">Timothy Halman</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Dartmouth North</td>
                        <td className="style1">Susan Leblanc</td>
                        <td className="style1">NSNDP</td>

                      </tr>
                      <tr>
                        <td className="style1">Dartmouth South</td>
                        <td className="style1">Claudia Chender</td>
                        <td className="style1">NSNDP</td>
                      </tr>
                      <tr>
                        <td className="style1">Digby-Annapolis </td>
                        <td className="style1">Jill Balser</td>
                        <td className="style1">PC</td>

                      </tr>
                      <tr>
                        <td className="style1">Eastern Passage </td>
                        <td className="style1"> Barbara Adams </td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Eastern Shore </td>
                        <td className="style1">Kent Smith</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Fairview-Clayton Park </td>
                        <td className="style1">Lina Hamid</td>
                        <td className="style1">NSNDP</td>
                      </tr>
                      <tr>
                        <td className="style1">Glace Bay-Dominion </td>
                        <td className="style1">John White</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1" style={{ height: '30px' }}>Guysborourgh-Tracadie</td>
                        <td className="style1">Greg Morrow</td>
                        <td className="style1"> PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Halifax Armdale </td>
                        <td className="style1">Rod Wilson</td>
                        <td className="style1">NSNDP</td>
                      </tr>
                      <tr>
                        <td className="style1">Halifax Atlantic </td>
                        <td className="style1">Brendan Maguire</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1" style={{ height: '30px' }}>Halifax Chebucto </td>
                        <td className="style1">Krista Gallagher</td>
                        <td className="style1">NSNDP</td>

                      </tr>
                      <tr>
                        <td className="style1">Halifax Citadel-Sable Island </td>
                        <td className="style1">Lisa Lachance</td>
                        <td className="style1">NSNDP</td>
                      </tr>
                      <tr>
                        <td className="style1">Halifax Needham </td>
                        <td className="style1">Suzy Hansen</td>
                        <td className="style1"> NSNDP</td>
                      </tr>
                      <tr>

                        <td className="style1">Hammonds Plains-Lucasville </td>
                        <td className="style1"> Rick Burns</td>
                        <td className="style1"> PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Hants East </td>
                        <td className="style1">John A. MacDonald</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Hants West </td>
                        <td className="style1">Melissa Sheehy-Richard</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Inverness </td>
                        <td className="style1">Kyle MacQuarrie</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Kings North </td>
                        <td className="style1">John A. Lohr</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1" style={{ height: '30px' }}>Kings South </td>
                        <td className="style1">Julie Vanexan</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Kings West </td>
                        <td className="style1">Chris Palmer</td>
                        <td className="style1"> PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Lunenburg </td>
                        <td className="style1">Susan Corkum-Greek</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Lunenburg West </td>
                        <td className="style1">Becky Druhan</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Northside Westmount </td>
                        <td className="style1">Fred Tilley</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Pictou Centre </td>
                        <td className="style1">Danny MacGillivray</td>
                        <td className="style1"> PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Pictou East </td>
                        <td className="style1"> Tim Houston </td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Pictou West </td>
                        <td className="style1">Marco MacLeod</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Preston </td>
                        <td className="style1">Twila Grosse</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Queens </td>
                        <td className="style1">Kim Masland</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Richmond </td>
                        <td className="style1"> Trevor Boudreau</td>
                        <td className="style1">PC</td>

                      </tr>

                      <tr>
                        <td className="style1">Sackville-Cobequid </td>
                        <td className="style1">Paul Wozney</td>
                        <td className="style1">NSNDP</td>
                      </tr>
                      <tr>
                        <td className="style1">Sackville-Uniacke </td>
                        <td className="style1">Brad Johns</td>
                        <td className="style1"> PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Shelburne </td>
                        <td className="style1">Nolan Young</td>
                        <td className="style1"> PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Sydney-Membertou </td>
                        <td className="style1">Derek Mombourquette</td>
                        <td className="style1">Liberal</td>

                      </tr>
                      <tr>
                        <td className="style1">Timberlea-Prospect </td>
                        <td className="style1"> Iain Rankin</td>
                        <td className="style1"> Liberal</td>
                      </tr>
                      <tr>
                        <td className="style1">Truro-Bible Hill-Millbrook-Salmon River </td>
                        <td className="style1"> Dave Ritcey </td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Victoria-The Lakes </td>
                        <td className="style1"> Dianne L. Timmins</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">Waverley-Fall River-Beaver Bank </td>
                        <td className="style1">Brian Wong</td>
                        <td className="style1">PC</td>

                      </tr>
                      <tr>
                        <td className="style1">Yarmouth </td>
                        <td className="style1">Nick Hilton</td>
                        <td className="style1">PC</td>
                      </tr>

                    </tbody>
                  </table>
                  {/* <br />
                  <h3>Financial Reporting Deadlines for the 42nd Provincial General Election</h3>
                  <br />
                  <p>Elections Nova Scotia reminds all nominated candidates, registered political parties, and third party advertisers from the 42nd provincial general election held on Tuesday, November 26, 2024, that financial reports are due in the weeks and months ahead. All reports must be sent to the Chief Electoral Officer.</p>
                  <br />
                  <p>Candidate tax receipts are due 30 days after election day, <strong>December 30, 2024</strong>.</p>
                  <br />
                  <p>Candidate financial reports, including audit reports, are due (80 days after writ) on <strong>February 28, 2025</strong>. It is also important to remember that there are <strong>fines of $50 per day</strong> for late candidate reports.</p>
                  <br />
                  <p>Registered party financial reports are due (120 days after Writ) on <strong>April 9, 2025</strong>.</p>
                  <br />
                  <p>Third party election advertising reports are due on <strong>March 26, 2025</strong>.</p>

                  <br /> */}
                  <br />
                  ENS is an independent non-partisan agency that reports to the members of the House of Assembly through the Speaker. Its mandate is to deliver provincial elections impartially and professionally.
 
                  {/* <br />
                  <h3>Provincial General Election Media Releases</h3>
                  <br />Elections Nova Scotia issues media releases throughout the provincial general election to update voters. Click here to view the list of <u><i><a href="https://electionsnovascotia.ca/news"> media releases for the provincial general election</a></i></u>. */}
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default PGE_42_MainPageInformation;
